<template>
  <div class="table-container">
    <el-table
      :data="tableData"
      :loading="loading"
      style="width: 100%"
      border
      stripe
      v-loading="loading"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="80"
        align="center"
      />
      <el-table-column
        prop="name"
        :label="$t('CountryManagement.countryName')"
        min-width="120"
        align="center"
      />
      <el-table-column
        prop="code"
        :label="$t('CountryManagement.countryCode')"
        width="120"
        align="center"
      />
      <el-table-column
        prop="is_after_sale"
        :label="$t('CountryManagement.afterSaleSupport')"
        width="120"
        align="center"
      >
        <template #default="scope">
          <el-tag
            :type="scope.row.is_after_sale === 1 ? 'success' : 'info'"
            size="small"
          >
            {{ scope.row.is_after_sale === 1 ? $t('CountryManagement.yes') : $t('CountryManagement.no') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="tax_number"
        :label="$t('CountryManagement.taxNumberRule')"
        min-width="150"
        align="center"
      >
        <template #default="scope">
          {{ scope.row.tax_number || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="postcode"
        :label="$t('CountryManagement.postcodeRule')"
        min-width="150"
        align="center"
      >
        <template #default="scope">
          {{ scope.row.postcode || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        :label="$t('CountryManagement.createdAt')"
        width="180"
        align="center"
      >
        <template #default="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="updated_at"
        :label="$t('CountryManagement.updatedAt')"
        width="180"
        align="center"
      >
        <template #default="scope">
          {{ formatDate(scope.row.updated_at) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('CountryManagement.operation')" width="200" align="center">
        <template #default="scope">
          <el-button
            size="small"
            type="primary"
            @click="handleEdit(scope.row)"
            v-if="hasPermission('country.edit')"
          >
            {{ $t('CountryManagement.edit') }}
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.row)"
            v-if="hasPermission('country.delete')"
          >
            {{ $t('CountryManagement.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 空数据状态 -->
    <div v-if="!loading && tableData.length === 0" class="empty-state">
      <el-empty :description="$t('CountryManagement.noData')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountryTableDisplay',
  props: {
    tableData: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const testPermissions = () => {
      const userId = localStorage.getItem('userId');
      const cacheKey = `subPermissions_${userId}`;
      const cache = localStorage.getItem(cacheKey);
      return cache ? JSON.parse(cache) : [];
    };
    
    return {
      subPermissions: testPermissions()
    };
  },
  methods: {
    // 检查权限
    hasPermission(permission) {
      if (!this.subPermissions || !Array.isArray(this.subPermissions)) {
        return false;
      }
      
      return this.subPermissions.includes(permission);
    },
    
    handleEdit(row) {
      this.$emit('edit', row);
    },
    
    handleDelete(row) {
      this.$emit('delete', row);
    },
    
    formatDate(dateString) {
      if (!dateString) return '-';
      try {
        const date = new Date(dateString);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    }
  }
};
</script>

<style scoped>
.table-container {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-height: 400px;
  height: auto;
  overflow: hidden;
}

.empty-state {
  padding: 40px;
  text-align: center;
}

.el-table {
  margin-bottom: 0;
  table-layout: fixed;
}

.el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.el-table td {
  padding: 12px 0;
}

.el-tag {
  font-weight: 500;
}
</style> 